import { DateTime } from 'luxon'

const VALID_SEVERITIES = ['success', 'error', 'warning', 'info']
const SEVERITY_ICONS = {
  success: 'mdi-check-circle-outline',
  error: 'mdi-alert-circle-outline',
  warning: 'mdi-alert-outline',
  info: 'mdi-information-outline'
}

function resolveLocale(locale) {
  if (locale) return locale
  if (typeof document !== 'undefined') {
    return document.documentElement.lang || 'en'
  }
  return 'en'
}

function ensureSeverity(severity) {
  return VALID_SEVERITIES.includes(severity) ? severity : 'info'
}

export function severityIcon(severity) {
  return SEVERITY_ICONS[ensureSeverity(severity)]
}

export function severityToneModifier(severity) {
  return ensureSeverity(severity)
}

export function isNotificationUnread(notification = {}) {
  return !notification.read_at && !notification.dismissed_at
}

export function parseNotificationDate(notification = {}) {
  const timestamp = notification.created_at_iso || notification.created_at
  if (!timestamp) return null
  const parsed = DateTime.fromISO(timestamp)
  return parsed.isValid ? parsed : null
}

export function formatRelativeNotificationTime(notification, { locale } = {}) {
  const dateTime = parseNotificationDate(notification)
  if (!dateTime) return ''
  return dateTime.toRelative({ locale: resolveLocale(locale) }) || ''
}

export function channelLabel(channel, t = (value) => value) {
  if (!channel) return ''
  const key = `notifications.admin.channels.${channel}`
  const translated = typeof t === 'function' ? t(key) : key
  return translated === key ? channel : translated
}

export function formatDeliveredChannels(channels, t, separator = ' • ') {
  if (!Array.isArray(channels) || channels.length === 0) return ''
  return channels.map((channel) => channelLabel(channel, t)).join(separator)
}

export function deliveryStatusLabel(status, t = (value) => value) {
  if (!status) return ''
  const key = `notifications.admin.delivery_statuses.${status}`
  const translated = typeof t === 'function' ? t(key) : key
  return translated === key ? status : translated
}

export function deliveryStatusReasonLabel(reason, t = (value) => value) {
  if (!reason) return ''
  const key = `notifications.admin.delivery_status_reasons.${reason}`
  const translated = typeof t === 'function' ? t(key) : key
  return translated === key ? reason : translated
}
